import React, { useState } from 'react';
import { Avatar, Empty, Form } from 'antd';
import { toneChip, toneRing, useStaffGroupTone } from 'widgets/Staff/useStaffGroupTone';
import styled from 'styled-components';
import shopSelectors from 'services/selectors/shop';
import type { IBlockHourHistoryItem } from 'services/types/blockHours';
import moment from 'utils/moment';
import HistoryCard from '../widgets/HistoryCard';
import HistoryAddMoreCard from '../widgets/HistoryAddMoreCard';

interface HistoryActivitiesProps {
}

const HistoryActivities: React.FC<HistoryActivitiesProps> = ({

}) => {
  const [selectedHistoryId, setSelectedHistoryId] = useState<string | null>(null);
  const blockHourHistories = shopSelectors.blockHourHistories();
  const staffs = shopSelectors.staffsAvailable() || [];
  const toneOf = useStaffGroupTone();
  const form = Form.useFormInstance();
  const handleViewDetail = (item: IBlockHourHistoryItem) => {
    setSelectedHistoryId(String(item.id));
    
    form.setFieldsValue({
      id: String(item.id),
      date: moment(item.startTime, 'MM-DD-YYYY hh:mm A'),
      selectedTimeStart: moment(item.startTime, 'MM-DD-YYYY hh:mm A').format('hh:mm A'),
      selectedTimeEnd: moment(item.endTime, 'MM-DD-YYYY hh:mm A').format('hh:mm A'),
      reason: item.reason,
    });
  };
  
  return (
    <HistoryPanel>
      <HistoryTitle>History &amp; Activities</HistoryTitle>
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) => {
          const selectedStaffId = getFieldValue('staffId');
          const selectedStaffObj = staffs.find((s) => s.id === selectedStaffId);

          return (
            <SelectedStaffWrap>
              <Avatar src={selectedStaffObj?.avatar} size={52} style={toneRing(toneOf(selectedStaffId))} />
              <SelectedStaffName><span style={toneChip(toneOf(selectedStaffId))}>{selectedStaffObj?.name.toUpperCase()}</span></SelectedStaffName>
            </SelectedStaffWrap>
          );
        }}
      </Form.Item>
      
      {(blockHourHistories?.data ?? []).length ? (
        <>
          <HistoryAddMoreCard
            active={selectedHistoryId === null}
            onClick={() => {
              setSelectedHistoryId(null);
              form.setFieldsValue({ id: undefined });
            }}
          />
          {(blockHourHistories?.data ?? []).map((item: IBlockHourHistoryItem) => (
            <HistoryCard
              key={item.id}
              item={item}
              active={selectedHistoryId === String(item.id)}
              onClick={() => handleViewDetail(item)}
            />
          ))}
        </>
      ) : (
        <Empty description="No history found" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </HistoryPanel>
  );
};

export default HistoryActivities;


const HistoryPanel = styled.div`
  width: 300px;
  border-left: 1px solid #e8e8e8;
  background: #fafafa;
  overflow-y: auto;
  padding: 14px 12px;
  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-thumb { background: #ddd; border-radius: 4px; }
`;

const HistoryTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.8px;
  color: #7b7b7b;
  margin-bottom: 12px;
  text-transform: uppercase;
`;

const SelectedStaffWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  margin-bottom: 14px;
`;

const SelectedStaffName = styled.span`
  font-weight: 700;
  font-size: 15px;
  color: #1a1a1a;
  letter-spacing: 1px;
`;

